import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AsignarListaEvento from '../admin/reservas/AsignarListaEvento';

// La ruta existente configura la lista que realmente consume Reservas.
export default function ConfigurarPaquetesReserva() {
  const { eventoId } = useParams();
  const navigate = useNavigate();
  return <AsignarListaEvento soloEventoId={eventoId} onVolver={() => navigate('/eventos')} />;
}
